import { render, staticRenderFns } from "./DuplicateDetailsDuplicate.vue?vue&type=template&id=d1a2d1e4&scoped=true"
import script from "./DuplicateDetailsDuplicate.vue?vue&type=script&lang=js"
export * from "./DuplicateDetailsDuplicate.vue?vue&type=script&lang=js"
import style0 from "./DuplicateDetailsDuplicate.vue?vue&type=style&index=0&id=d1a2d1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a2d1e4",
  null
  
)

export default component.exports